// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as fonts from '@helpcenter/styles/src/fonts';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const SidebarHeader = styled.h3`
	${fonts.h700};
	margin-top: ${token('space.200', '16px')};
	margin-bottom: ${token('space.300', '24px')};
	flex-shrink: 0; /* only want to shrink the draggable cards list */
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const EmptyStateMessage = styled.p`
	font-size: ${fonts.xsmall};
	color: ${token('color.text.subtle', '#6B778C')};
	padding-top: ${token('space.100', '8px')};
	padding-bottom: ${token('space.100', '8px')};
	width: 60%;
	margin: auto;
`;
